export const ACCOUNT_DELETION_ROUTES = Object.freeze({
    authorize: "/account-deletion/authorize",
    recovery: "/account-deletion/recovery",
    restricted: "/account-deletion/restricted",
    status: "/account-deletion/status",
});

const ACCOUNT_DELETION_PUBLIC_PATHS = new Set(Object.values(ACCOUNT_DELETION_ROUTES));

export const isAccountDeletionPublicPath = (pathname) => {
    if (typeof pathname !== "string") {
        return false;
    }
    const normalizedPathname = pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    return ACCOUNT_DELETION_PUBLIC_PATHS.has(normalizedPathname);
};

export const replaceWithAccountDeletionDocument = (pathname) => {
    if (!ACCOUNT_DELETION_PUBLIC_PATHS.has(pathname)) {
        throw new TypeError("Account-deletion document navigation requires an allowlisted path");
    }
    window.location.replace(pathname);
};
